var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('foreignObject',{attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":"14"}},[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"image","width":_vm.width,"height":"14"}}):_c('v-text-field',{staticClass:"hmi-input",class:{
      'disable-input': _vm.disable,
      'error-input': _vm.hasError,
      'sm-input': _vm.size === 'sm',
      'md-input': _vm.size === 'md',
      'lg-input': _vm.size === 'lg',
    },attrs:{"type":_vm.disable ? 'text' : 'number',"value":_vm.disable ? 'CALC' : _vm.paramData.value,"suffix":_vm.unit,"disabled":_vm.disable,"readonly":_vm.readonly,"flat":"","solo":"","dense":""},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }